import { render, staticRenderFns } from "./pizzaPage.vue?vue&type=template&id=71be1d6f&scoped=true&"
import script from "./pizzaPage.vue?vue&type=script&lang=js&"
export * from "./pizzaPage.vue?vue&type=script&lang=js&"
import style0 from "./pizzaPage.vue?vue&type=style&index=0&id=71be1d6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71be1d6f",
  null
  
)

export default component.exports